import { Component, inject } from '@angular/core';
import { MobileService } from '@lib/util';

@Component({
    selector: 'smart-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent {
    mobileService = inject(MobileService);
}
